import React from "react";
import Login from "component/login";
function App() {
  return (
    <div className="w-full h-full">
      <Login />
    </div>
  );
}

export default App;
